import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Calendar = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16 9H4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M4 7C4 5.89543 4.89543 5 6 5H14C15.1046 5 16 5.89543 16 7V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V7Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />;
    t2 = <path d="M7 3.5L7 6.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M13 3.5L13 6.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default Calendar;